/**
 * @file       Account.css
 * @author     Alex Huctwith <alex@kingsds.network>
 * @author     Kevin Yu <kevin@distributive.network>
 *
 * @date       April 2022
 *
 *             Style for the account components
 */

.accountEntry button {
  margin: 0;
  color: var(--primary-hue-main);
  vertical-align: middle;
}

.accountEntry .label {
  max-width: 0;
  padding: 1em 0;
}

.accountEntry .copy-to-clipboard {
  margin-left: 0.25em;
  border: none;
  background-color: transparent;
  min-width: initial;
}

.accountEntry .copyToClipboard + button {
  border: none;
  min-width: initial;
}

.accountEntry .copy-to-clipboard img {
  height: auto;
  min-width: 12px;
  width: 12px;
  opacity: 0.4;
}

.accountEntry .copyToClipboard img:hover {
  filter: var(--primary-hue-main-filter);
  opacity: 1;
}

.accountEntry td:nth-last-child(2) {
  width: 100%;
}

.accounts-table td:nth-last-child(2) button.dcc {
  margin-left: auto;
}

.accounts-table-container th:nth-child(3) {
  position: relative;
  left: 13px;
}

.accountEntry [id^="unlockAccount"]:active {
  transform: scale(0.9);
}

.account-label {
  button {
    color: var(--content-hue-main);
    overflow: hidden;
    max-width: 260px;
    text-overflow: ellipsis;
    min-width: 1rem;
    min-height: 1rem;
  }

  button:hover {
    color: var(--primary-hue-main);
    text-decoration: underline;
  }
}

.locked-icon {
  height: 14px;
  width: 14px;
  fill: var(--content-hue-main);
}

/* An extra div is needed here to allow both ellipsis text truncation as well as center v-align w/ the copy icon */
.accountNumber > div {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.accountNumber > div:hover {
  opacity: 1;

  button {
    color: var(--primary-hue-main);
    text-decoration: underline;
  }
}

.accountNumber > div button {
  color: var(--content-hue-main);
}

.accountNumber > div:hover img {
  opacity: 1;
  filter: var(--primary-hue-main-filter);
}

.accountNumber > div .text {
  white-space: nowrap;
  color: var(--content-hue-main);
}

/* TODO: Remove this when the toast notification MR lands */
.accountNumber button[data-state="closed"] {
  display: none;
}

.account-entry-transaction-link {
  display: flex;
  height: 100%;
  width: 100%;
}

.accountEntry td {
  white-space: nowrap;
  text-overflow: ellipsis;
}
